import { Component, Signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OmniSearchOption, OmniSearchService } from './omni-search.service';

@Component({
  selector: 'app-omni-search',
  templateUrl: './omni-search.component.html',
  styleUrls: ['./common.scss'],
})
export class OmniSearchComponent {
  options: Signal<OmniSearchOption[]>;

  constructor(private omniSearchService: OmniSearchService, public dialogRef: MatDialogRef<OmniSearchComponent>) {
    this.options = this.omniSearchService.options;
  }

  checkShortcut(searchTerm: string, options: OmniSearchOption[]): void {
    options.forEach((option) => {
      if (option.shortcut === searchTerm.toLowerCase()) {
        this.onOptionSelected(option);
      }
    });
  }

  onOptionSelected(option: OmniSearchOption): void {
    if (option.callback) {
      option.callback();
    }
    this.dialogRef.close();
  }
}
